<template>
  <v-layout class="sub-heading-ctr">
    <v-flex lg3>
      <v-layout justify-start align-center v-if="backLink">
        <v-btn
          class="back-button"
          link
          depressed
          :to="backLink.link"
          autoid="back-to-list"
          id="back-to-sub-brand-list-btn"
        >
          <v-icon>chevron_left</v-icon>
          {{ backLink.text }}
        </v-btn>
      </v-layout>
      <v-spacer v-else></v-spacer>
    </v-flex>
    <v-flex lg6>
      <v-layout justify-center align-center class="heading">
        <span autoid="lbl-sub-header">{{ subBrandCount }} {{ headerText }}</span>
        <span class="text-lg-center mb-0 caption">{{ headerSubText }}</span>
      </v-layout>
    </v-flex>
    <v-flex lg3>
      <v-layout justify-end align-center>
        <div v-if="actionData">
          <template v-for="(action, index) in actionData">
            <div :key="index" class="action-ctr">
              <v-btn
                v-on="action.actionMethod ? {click: action.actionMethod} : {}"
                :to="action.actionLink"
                :color="action.actionType"
                :outlined="action.outlined"
                :disabled="action.disabled"
                depressed
                :autoid="action.autoid"
              >{{ action.displayName }}</v-btn>
            </div>
          </template>
        </div>
        <v-spacer v-else></v-spacer>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
// Props Object Model  //
/*   subHeaderConfig: {
      headerText: 'Create Sub-brand',
      headerSubText: 'test sub heading',
      subBrandCount: 10,
      backLink: {
        text: 'Back to Sub-brand List',
        link: ''
      },
      actions: [
        {
          displayName: 'Save & Continue',
          controlName: 'button',
          actionType: 'primary',
          actionMethod: 'continueStep'
        },
        {
          displayName: 'Save',
          controlName: 'button',
          actionType: 'primary',
          actionMethod: 'continueStep'
        }
      ]
    } */
export default {
  data() {
    return {
      config: this.subHeaderConfig,
      subBrandCount: this.subHeaderConfig.subBrandCount,
      headerText: this.subHeaderConfig.headerText,
      headerSubText: this.subHeaderConfig.headerSubText,
      backLink: this.subHeaderConfig.backLink,
      actionData: this.subHeaderConfig.actions
    }
  },
  props: {
    subHeaderConfig: Object
  },
  methods: {},
  computed: {},
  mounted: function() {
      this.$root.$on('updateCount', (count) => { 
        this.subBrandCount = count;
      })
  }
}
</script>

<style lang="scss">
.sub-heading-ctr {
  padding: 0px 24px;
  border-bottom: 1px solid #d6d6d6;
  background: #fafafa;
}
.sub-heading-ctr .layout {
  height: 63px;
}
.heading {
  flex-direction: column;
  justify-content: center;
  color: #383838;
  font-size: 18px;
}
.sub-heading-ctr .back-button {
  background: #fafafa !important;
  padding-left: 0 !important;
  color: #0070c9 !important;
  text-transform: none;
  .v-icon {
    color: #0070c9;
  }
}

.caption {
  color: #888888;
}

.action-ctr .v-btn {
  margin-left: 12px;
}
.action-ctr {
  display: inline-block;
  a {
    text-transform: none;
  }
}
</style>
